var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 4.167H5c-.92 0-1.666.746-1.666 1.666v10c0 .92.746 1.667 1.666 1.667h10c.92 0 1.667-.746 1.667-1.667v-10c0-.92-.746-1.666-1.667-1.666M13.334 2.5v3.333M6.667 2.5v3.333M3.334 9.167h13.333M8.334 13.333h3.333"
  })));
};
export default SvgCalendar;